var map = {
	"./CAT_logo.png": 32283,
	"./PL_01.png": 28823,
	"./PL_02.png": 70716,
	"./awaria.png": 55910,
	"./category/kategoria-10.png": 34007,
	"./category/kategoria-10_over.png": 96498,
	"./category/kategoria-11.png": 34510,
	"./category/kategoria-11_over.png": 46437,
	"./category/kategoria-2.png": 53340,
	"./category/kategoria-2_over.png": 70439,
	"./category/kategoria-3.png": 66405,
	"./category/kategoria-3_over.png": 9148,
	"./category/kategoria-5.png": 36947,
	"./category/kategoria-5_over.png": 78486,
	"./category/kategoria-7.png": 47073,
	"./category/kategoria-7_over.png": 92992,
	"./category/kategoria-8.png": 90918,
	"./category/kategoria-8_over.png": 56525,
	"./category/kategoria-9.png": 29935,
	"./category/kategoria-9_over.png": 64954,
	"./dalej.png": 58747,
	"./dalej_over.png": 51566,
	"./dostepny.png": 1367,
	"./filtry.png": 4953,
	"./filtry_over.png": 32488,
	"./kategoria-10.png": 19824,
	"./kategoria-10_over.png": 515,
	"./kategoria-11.png": 35577,
	"./kategoria-11_over.png": 59656,
	"./kategoria-2.png": 39585,
	"./kategoria-2_over.png": 96800,
	"./kategoria-3.png": 54968,
	"./kategoria-3_over.png": 62107,
	"./kategoria-5.png": 3470,
	"./kategoria-5_over.png": 82021,
	"./kategoria-7.png": 45852,
	"./kategoria-7_over.png": 74247,
	"./kategoria-8.png": 49451,
	"./kategoria-8_over.png": 26814,
	"./kategoria-9.png": 28322,
	"./kategoria-9_over.png": 60929,
	"./kola_01.png": 48666,
	"./kola_02.png": 47294,
	"./kontrola.png": 23249,
	"./kontrola_02.png": 25400,
	"./kontrola_over.png": 23056,
	"./niedostepny.png": 2851,
	"./os_01.png": 69397,
	"./os_01_02.png": 9452,
	"./os_01_03.png": 21077,
	"./os_02.png": 2046,
	"./os_02_02.png": 16825,
	"./os_02_03.png": 19920,
	"./pobierz.png": 71548,
	"./pobierz_over.png": 84007,
	"./powrot.png": 22020,
	"./powrot_over.png": 20927,
	"./preferencje.png": 73816,
	"./preferencje_over.png": 8315,
	"./rozwin.png": 93140,
	"./szukaj.png": 20211,
	"./szukaj_over.png": 56566,
	"./traffic.png": 32098,
	"./uwaga.png": 44800,
	"./uzytkownicy.png": 91921,
	"./uzytkownicy_over.png": 88848,
	"./uzytkownik.png": 35730,
	"./uzytkownik_over.png": 45329,
	"./wlaczony.png": 74482,
	"./wykres.png": 90782,
	"./wykres_over.png": 90357,
	"./wyloguj.png": 78042,
	"./wyloguj_over.png": 5257,
	"./zamknij.png": 53527,
	"./zamknij_over.png": 91954,
	"./zaznacz_01.png": 56194,
	"./zaznacz_02.png": 95929,
	"./znak_01.png": 29439,
	"./znak_02.png": 15876,
	"./znak_03.png": 58381,
	"./znak_04.png": 60466,
	"./znak_05.png": 25819,
	"./znak_06.png": 70784,
	"./znak_07.png": 25609,
	"./znak_08.png": 26718,
	"./zwin.png": 18957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;